import { inertia } from './basler-components.es729.js';
import { keyframes } from './basler-components.es730.js';
import { spring } from './basler-components.es747.js';

const transitionTypeMap = {
    decay: inertia,
    inertia,
    tween: keyframes,
    keyframes: keyframes,
    spring,
};
function replaceTransitionType(transition) {
    if (typeof transition.type === "string") {
        transition.type = transitionTypeMap[transition.type];
    }
}

export { replaceTransitionType };
